// extracted by mini-css-extract-plugin
export default {"sheetOptimizeType":"SheetsMenu__sheetOptimizeType--i_jHpTH"};